import React, { useState, useEffect } from 'react';
// import Swiper core and required modules
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper";
import axios from "axios";

// install Swiper modules
SwiperCore.use([Navigation, Pagination, EffectFade]);

const API_URL = "https://test.campfr.com/api/get_home_feedback/";
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

function Testimonial3() {

  // State management for data, loading status, and error handling
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */

    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });

        console.log("API Response:", response.data);

        const data = response.data; // Use the response data directly
        setReviews(data);

        setLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error);



  // Map over the fetched workshops to render slides
  const reviewSlides = reviews.map((review, index) => {

    return (

      <SwiperSlide className="swiper-slide">
        <TestimonialCardBeta
          image={`/images/courses/tiny/${review.image}`}
          name={review.name}
          year={review.year}
          reviewText={review.reviewText}
        />
      </SwiperSlide>

    );

  });






  const testimonial3slide = {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 20,
    loop: true,
    roundLengths: true,
    autoplay: {
      delay: 15000,
    },
    navigation: {
      nextEl: ".testi-next4",
      prevEl: ".testi-prev4",
    },
    breakpoints: {
      480: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      992: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };
  return (
    <>
      <div className="testimonial-area testimonial-style-three pt-110 pb-110">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-5 col-sm-10">
              <div className="section-head-alpha text-lg-start text-center">
                <h2 className="text-white">CAMP alumni reviews</h2>
                <p className="text-white">
                  A workshop at CAMP is just the start of a supportive relationship - we work with our alumni to develop their practice long term. Read what some of our previous supported artists say about us...
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-10 d-flex justify-content-end">
              <div className="slider-arrows text-center d-lg-flex flex-row d-none gap-5">
                <div
                  className="testi-prev4"
                  tabIndex={0}
                  role="button"
                  aria-label="Previous slide"
                >
                  {" "}
                  <i className="bi bi-arrow-left" />
                </div>
                <div
                  className="testi-next4"
                  tabIndex={0}
                  role="button"
                  aria-label="Next slide"
                >
                  <i className="bi bi-arrow-right" />
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center justify-content-center">
            <div className="col-lg-12">
              <Swiper
                className="swiper testimonial-slider-three"
                {...testimonial3slide}
              >
                <div className="swiper-wrapper">



                  {reviewSlides}


                </div>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
function TestimonialCardBeta(props) {
  return (
    <>
      <div className="testimonial-card-beta mx-auto">
        <div className="testimonial-quote-icon">
          <img
            src={process.env.PUBLIC_URL + "/images/icons/quote-review.svg"}
            alt="testimonial-img"
            className="img-fluid"
          />
        </div>
        <div className="testimonial-card-body">
          <div className="testimonial-info">
            <div className="reviewr-info">
              <div className="course-image-cropper">
                <img src={`${process.env.PUBLIC_URL} ${props.image}`} className="round-course-image" alt="" />
              </div>
              <div className="reviwer-info-cotn">
                <h5 className="reviewer-name">{props.name}</h5>
                <i>CAMP alumni, {props.year}</i>
              </div>
            </div>
          </div>
          <div className="review-texts">
            <p>{props.reviewText} </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default Testimonial3;
